/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phonePromptAssetMetadataResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phonePromptAssetMetadataResponseOutputOwnerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phonePromptAssetMetadataResponseOutputSizeBytesExclusiveMin = 0;
export const phonePromptAssetMetadataResponseOutputSizeBytesMax = 1048576;

export const phonePromptAssetMetadataResponseOutputDurationMsExclusiveMin = 0;
export const phonePromptAssetMetadataResponseOutputDurationMsMax = 60000;

export const phonePromptAssetMetadataResponseOutputDigestRegExp = new RegExp('^[a-f0-9]{64}$');

export const PhonePromptAssetMetadataResponseOutput = zod.object({
  id: zod.uuid().regex(phonePromptAssetMetadataResponseOutputIdRegExp),
  ownerType: zod.enum(['team', 'customer']),
  ownerId: zod.uuid().regex(phonePromptAssetMetadataResponseOutputOwnerIdRegExp),
  slot: zod.enum(['inboundGreeting', 'clientCodePrompt', 'beforeTransfer', 'voicemailPrompt']),
  mimeType: zod.literal('audio/mpeg'),
  sizeBytes: zod
    .int()
    .gt(phonePromptAssetMetadataResponseOutputSizeBytesExclusiveMin)
    .max(phonePromptAssetMetadataResponseOutputSizeBytesMax),
  durationMs: zod
    .int()
    .gt(phonePromptAssetMetadataResponseOutputDurationMsExclusiveMin)
    .max(phonePromptAssetMetadataResponseOutputDurationMsMax),
  digest: zod.string().regex(phonePromptAssetMetadataResponseOutputDigestRegExp),
});

export type PhonePromptAssetMetadataResponseOutput = zod.input<
  typeof PhonePromptAssetMetadataResponseOutput
>;
export type PhonePromptAssetMetadataResponseOutputOutput = zod.output<
  typeof PhonePromptAssetMetadataResponseOutput
>;
